export default __webpack_public_path__ + "static/media/404-logo.84917e2e.png";